module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29bf5a4e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/App.vue
// module id = 251
// module chunks = 2